export type ButtonSize = 'sm' | 'md' | 'lg'

const BASE =
  'group inline-flex max-w-full items-center justify-center gap-2.5 rounded-[8px] bg-orange text-center font-heading font-bold uppercase tracking-[0.06em] text-charcoal shadow-[inset_0_1px_0_rgba(255,255,255,0.35),0_14px_28px_-14px_rgba(244,122,38,0.6)] transition-[background-color,transform] duration-150 ease-out hover:bg-orange-light active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-arc/60'

const SIZES: Record<ButtonSize, string> = {
  sm: 'min-h-[46px] whitespace-nowrap px-4 text-[1rem]',
  md: 'min-h-[52px] whitespace-nowrap px-6 text-[1.08rem]',
  // On phones the label stays on one line whenever it fits (identical look), but
  // may wrap instead of spilling past the screen edge in very narrow containers
  // such as the offer card at 360px. From sm up it never wraps.
  lg: 'min-h-[58px] whitespace-normal px-3.5 text-[0.98rem] leading-[1.1] tracking-[0.04em] min-[390px]:px-5 min-[390px]:text-[1.06rem] sm:whitespace-nowrap sm:px-8 sm:text-[1.2rem] sm:tracking-[0.06em]',
}

/** Primary orange button classes, shared by purchase and scroll CTAs. */
export function primaryButtonClass(size: ButtonSize = 'md'): string {
  return `${BASE} ${SIZES[size]}`
}
